import {adminHttpClient} from "../commons/adminHttpClient";

const deleteNewsTicker = (id : string) : Promise<any> => {
    return adminHttpClient.delete(`/NewsTickerAudits/Delete`, {
        data:{id : id}
    })
}

export default deleteNewsTicker;